import { getColorCSSVariable, convertNamedColorToColorVariant } from '@klv/shared/utils/functions';

import type { THeroBackground } from '../types';
import type { TColorVariant } from '@klv/shared/styles/types';

export const useHeroColors = (background: THeroBackground) => {
  const cssBackgroundColor = getColorCSSVariable(background);
  const backgroundColor = convertNamedColorToColorVariant(background as TColorVariant);

  return {
    cssBackgroundColor,
    backgroundColor: backgroundColor as TColorVariant,
  };
};
